export default __webpack_public_path__ + "static/media/facebook.84886ad4.svg";